import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "Ebene_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 167.48 223.05"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  class: "cls-1",
  d: "M83.73 126.21c-23.42 0-42.47-19.05-42.47-42.47s19.05-42.47 42.47-42.47 42.47 19.05 42.47 42.47-19.06 42.47-42.47 42.47Zm0-78.19c-19.69 0-35.71 16.02-35.71 35.71s16.02 35.71 35.71 35.71 35.71-16.02 35.71-35.71-16.02-35.71-35.71-35.71Z"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "cls-1",
  d: "m83.73 223.04-2.52-2.82C77.9 216.51 0 128.88 0 83.73S37.56 0 83.73 0s83.75 37.56 83.75 83.74-77.91 132.78-81.22 136.49l-2.52 2.82Zm0-216.29C41.29 6.76 6.76 41.29 6.76 83.74c0 38.23 63.43 113.48 76.97 129.11 13.54-15.63 76.99-90.88 76.99-129.11 0-42.44-34.53-76.98-76.99-76.98Z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }